import * as React from "react";
import { useRef } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./styles/NavBar.css";

const pages = ["About", "Projects", "Experience"];

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

function NavBar() {
  const appBarRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  const navigateToPage = (page) => {
    const sectionId = page.toLowerCase().replace(/\s+/g, "-");
    const section = document.getElementById(sectionId);
    const navbar = document.getElementById("nav-app-bar");

    if (!section || !navbar) return;

    const navbarHeight = navbar.offsetHeight;

    const isMobile = window.matchMedia("(max-width: 1024px)").matches;

    if (isMobile) {
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - navbarHeight,
        behavior: "smooth",
      });
    } else {
      const parent = section.closest("#left-column") || section.closest("#right-column");

      if (parent && parent.scrollTo) {
        parent.scrollTo({
          top: section.offsetTop - navbarHeight,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <HideOnScroll>
          <AppBar ref={appBarRef} id="nav-app-bar">
            <Container id="nav-container">
              <Toolbar id="nav-toolbar">
                <Box id="nav-box">
                  {pages.map((page, index) => (
                    <Button
                      key={index}
                      onClick={() => navigateToPage(page)}
                      className="nav-button"
                    >
                      {page}
                    </Button>
                  ))}
                </Box>
              </Toolbar>
            </Container>
          </AppBar>
        </HideOnScroll>
      ) : (
        <AppBar ref={appBarRef} id="nav-app-bar">
          <Container id="nav-container">
            <Toolbar id="nav-toolbar">
              <Box id="nav-box">
                {pages.map((page, index) => (
                  <Button
                    key={index}
                    onClick={() => navigateToPage(page)}
                    className="nav-button"
                  >
                    {page}
                  </Button>
                ))}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )}
    </>
  );
}

export default NavBar;
